import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
Swiper.use([Navigation, Pagination]);
// Ждем полной загрузки DOM
document.addEventListener('DOMContentLoaded', function() {

  let swiperInstances = [];

  // Конфигурация для всех слайдеров
  const swiperConfig = {
    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
    loop: false,
    speed: 500,
    grabCursor: true,
    initialSlide: 0,
    slideToClickedSlide: false,

    // Пагинация (точки) - ВСЕГДА видима
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: false, // Отключаем динамические точки
      type: 'bullets',
      renderBullet: function (index, className) {
        return '<span class="' + className + '"></span>';
      }
    },

    // Адаптивность
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 15,
        centeredSlides: true,
        pagination: {
          dynamicBullets: false,
        }
      },
      576: {
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
        pagination: {
          dynamicBullets: false,
        }
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 25,
        centeredSlides: true,
        pagination: {
          dynamicBullets: false,
        }
      },
      992: {
        slidesPerView: 1,
        spaceBetween: 30,
        centeredSlides: false,
        pagination: {
          dynamicBullets: false,
        }
      },
      1200: {
        slidesPerView: 1,
        spaceBetween: 30,
        centeredSlides: false,
        pagination: {
          dynamicBullets: false,
        }
      },
      1400: {
        slidesPerView: 2.5,
        spaceBetween: 30,
        centeredSlides: false,
        // На десктопе можно скрыть точки, если нужно
        pagination: {
          enabled: false, // Отключаем точки на десктопе
        }
      }
    },

    // Навигация
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },

    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
    },

    // Свободное перемещение
    freeMode: false,

    // Отскок на краях
    resistance: true,
    resistanceRatio: 0.85,

    // Следим за видимостью
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
  };

  // Функция инициализации всех слайдеров
  function initAllSwipers() {
    const swiperElements = document.querySelectorAll('.mySwiper');

    swiperElements.forEach((element, index) => {
      // Проверяем, не инициализирован ли уже
      if (!element.swiper) {
        // Создаем уникальный класс для пагинации этого слайдера
        const paginationClass = `swiper-pagination-${index}`;
        const paginationEl = element.querySelector('.swiper-pagination');
        if (paginationEl) {
          paginationEl.classList.add(paginationClass);
        }

        // Клонируем конфиг и добавляем уникальный класс для пагинации
        const config = {...swiperConfig};
        config.pagination = {
          ...swiperConfig.pagination,
          el: `.${paginationClass}`
        };

        const instance = new Swiper(element, config);
        swiperInstances.push(instance);

        // Принудительно показываем пагинацию после инициализации
        setTimeout(() => {
          if (paginationEl) {
            paginationEl.style.display = 'flex';
            paginationEl.style.opacity = '1';
            paginationEl.style.visibility = 'visible';
          }
        }, 100);
      }
    });
  }

  // Инициализируем все слайдеры
  initAllSwipers();

  // Принудительно показываем точки на всех слайдерах
  setTimeout(() => {
    document.querySelectorAll('.swiper-pagination').forEach(pagination => {
      pagination.style.display = 'flex';
      pagination.style.opacity = '1';
      pagination.style.visibility = 'visible';
    });
  }, 200);

  // Обновление при изменении размера окна
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      // Принудительно показываем точки при ресайзе
      document.querySelectorAll('.swiper-pagination').forEach(pagination => {
        pagination.style.display = 'flex';
        pagination.style.opacity = '1';
        pagination.style.visibility = 'visible';
      });

      swiperInstances.forEach(instance => {
        if (instance && instance.update) {
          instance.update();
        }
      });
    }, 250);
  });

  // Слушаем клики по кнопкам табов
  const tabButtons = document.querySelectorAll('.tabs__nav-btn');

  tabButtons.forEach((button) => {
    button.addEventListener('click', function() {
      // Небольшая задержка для завершения анимации смены таба
      setTimeout(() => {
        swiperInstances.forEach(instance => {
          if (instance && instance.update) {
            instance.update();
            instance.slideTo(0, 0); // Возвращаем на первый слайд
          }
        });
        // Принудительно показываем точки после смены таба
        setTimeout(() => {
          document.querySelectorAll('.swiper-pagination').forEach(pagination => {
            pagination.style.display = 'flex';
            pagination.style.opacity = '1';
            pagination.style.visibility = 'visible';
          });
        }, 50);
      }, 100);
    });
  });

});
